import { render, staticRenderFns } from "./ProviderPayments.vue?vue&type=template&id=cfc330e8&lang=pug&"
import script from "./ProviderPayments.vue?vue&type=script&lang=js&"
export * from "./ProviderPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports